import {
    AUTH_LOGIN,
    AUTH_CHECK,
    AUTH_LOGOUT,
    AUTH_FORGOT,
    AUTH_RESET,
    SET_USERDATA,
    AUTH_VERIFY_TOKEN,
    GENERAL_SETTING,
    POS_ADD_TO_CART,
    POS_REMOVE_FROM_CART,
    POS_UPDATE_TO_CART_ITEM_QUANTITY,
    POS_ADD_TO_ORDER_DISCOUNT,
    POS_REMOVE_ORDER,
    POS_UPDATE_TO_ORDER,
    TABLE_ADD_TO_CART,
    TABLE_REMOVE_FROM_CART,
    TABLE_UPDATE_TO_CART_ITEM_QUANTITY,
    TABLE_REMOVE_ORDER,
    TABLE_UPDATE_TO_ORDER,
    TABLE_SIDE_DRAWER,
    ADMIN_SIDE_DRAWER,
    DEVICE_TOKEN,
} from '@/store/action-types';

export function authLogin(payload) {
    return {
        type: AUTH_LOGIN,
        payload,
    };
}

export function authLogout() {
    return {
        type: AUTH_LOGOUT,
    };
}

export function authForgot(payload) {
    return {
        type: AUTH_FORGOT,
        payload,
    };
}

export function authReset(payload) {
    return {
        type: AUTH_RESET,
        payload,
    };
}

export function authCheck() {
    return {
        type: AUTH_CHECK,
    };
}

export function setUserData(payload) {
    return {
        type: SET_USERDATA,
        payload,
    };
}

export function authVerifyToken(payload) {
    return {
        type: AUTH_VERIFY_TOKEN,
        payload,
    };
}

export function generalSetting(payload) {
    return {
        type: GENERAL_SETTING,
        payload,
    };
}

export function addOrUpdateCartItemPOS(payload) {
    return {
        type: POS_ADD_TO_CART,
        payload,
    };
}

export function updateCartItemQuantityPOS(payload) {
    return {
        type: POS_UPDATE_TO_CART_ITEM_QUANTITY,
        payload,
    };
}

export function addToOrderDiscountPOS(payload) {
    return {
        type: POS_ADD_TO_ORDER_DISCOUNT,
        payload,
    };
}

export function updateOrderPOS(payload) {
    return {
        type: POS_UPDATE_TO_ORDER,
        payload,
    };
}

export function removeFromCartPOS(payload) {
    return {
        type: POS_REMOVE_FROM_CART,
        payload,
    };
}

export function removeOrderPOS(payload) {
    return {
        type: POS_REMOVE_ORDER,
        payload,
    };
}

export function setTableSideDrawer(payload) {
    return {
        type: TABLE_SIDE_DRAWER,
        payload,
    };
}

export function addOrUpdateCartItemTable(payload) {
    return {
        type: TABLE_ADD_TO_CART,
        payload,
    };
}

export function updateCartItemQuantityTable(payload) {
    return {
        type: TABLE_UPDATE_TO_CART_ITEM_QUANTITY,
        payload,
    };
}

export function updateOrderTable(payload) {
    return {
        type: TABLE_UPDATE_TO_ORDER,
        payload,
    };
}

export function removeFromCartTable(payload) {
    return {
        type: TABLE_REMOVE_FROM_CART,
        payload,
    };
}

export function removeOrderTable(payload) {
    return {
        type: TABLE_REMOVE_ORDER,
        payload,
    };
}

export function setAdminSideDrawer(payload) {
    return {
        type: ADMIN_SIDE_DRAWER,
        payload,
    };
}

export function setDeviceToken(payload) {
    return {
        type: DEVICE_TOKEN,
        payload,
    };
}
